import { useEffect } from 'react';
import { CRUSHSHY_SITE } from '../seo/crushshySeo';

function upsertMeta(selector, attrs) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const key = attrs.property ? 'property' : 'name';
    el.setAttribute(key, attrs.property || attrs.name);
    document.head.appendChild(el);
  }
  if (attrs.content != null) el.setAttribute('content', attrs.content);
  return el;
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Met à jour title + meta SEO pour les pages publiques CrushShy (SPA).
 */
export default function CrushShyPageHead({
  title,
  description,
  path = '/crushshy',
  noIndex = false,
  ogType = 'website',
}) {
  useEffect(() => {
    const canonical = `${CRUSHSHY_SITE}${path.startsWith('/') ? path : `/${path}`}`;
    const prevTitle = document.title;

    document.title = title;
    document.documentElement.lang = 'fr';

    upsertMeta('meta[name="description"]', { name: 'description', content: description });
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: title });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
    upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonical });
    upsertMeta('meta[property="og:type"]', { property: 'og:type', content: ogType });
    upsertMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: 'CrushShy' });
    upsertMeta('meta[property="og:locale"]', { property: 'og:locale', content: 'fr_FR' });
    upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: title });
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    upsertMeta('meta[name="robots"]', {
      name: 'robots',
      content: noIndex ? 'noindex, nofollow' : 'index, follow',
    });

    upsertLink('canonical', canonical);
    const ogImage = `${CRUSHSHY_SITE}/crushshy/og-card.png`;
    upsertMeta('meta[property="og:image"]', { property: 'og:image', content: ogImage });
    upsertMeta('meta[property="og:image:width"]', { property: 'og:image:width', content: '1200' });
    upsertMeta('meta[property="og:image:height"]', { property: 'og:image:height', content: '630' });
    upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: ogImage });

    return () => {
      document.title = prevTitle;
    };
  }, [title, description, path, noIndex, ogType]);

  return null;
}
